import { render, staticRenderFns } from "./AssetStep.vue?vue&type=template&id=06287520&scoped=true&"
import script from "./AssetStep.vue?vue&type=script&lang=js&"
export * from "./AssetStep.vue?vue&type=script&lang=js&"
import style0 from "./AssetStep.vue?vue&type=style&index=0&id=06287520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06287520",
  null
  
)

export default component.exports